var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image",style:(_vm.style)},[_c('img',{class:{ 'is-rounded': _vm.round },attrs:{"alt":_vm.account.name,"src":_vm.primary},on:{"error":_vm.useFallback}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bbcd35a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/taskflex/users/components/Avatar.vue
// module id = 9QEE
// module chunks = 1